import { ABHA_HERO_PHONE_MAX_LENGTH } from '@components/NewProduct/constants'

export const sanitizeAbhaPhoneNumber = (value: string) => {
  const digits = value.replace(/\D/g, '')

  return digits.length > ABHA_HERO_PHONE_MAX_LENGTH
    ? digits.slice(-ABHA_HERO_PHONE_MAX_LENGTH)
    : digits.slice(0, ABHA_HERO_PHONE_MAX_LENGTH)
}

export const isCompleteAbhaPhoneNumber = (value: string) => value.length === ABHA_HERO_PHONE_MAX_LENGTH
